import { Component, Input } from '@angular/core';
@Component({
  selector: 'app-entity-name',
  templateUrl: './entity-name.component.html',
  styleUrls: ['./entity-name.component.scss']
})

export class EntityNameComponent {
  @Input() entity: {
    firstName: string;
    lastName: string;
    middleName: string;
    nickname: string;
    pronouns?: string;
  };

  /** Additional css class which wraps but the pronoun and names */
  @Input() wrapClass = 'name-wrap';


  get pronouns() {
    return this.entity?.pronouns ? `(${this.entity.pronouns})` : '';
  }

  constructor() { }

}
